/*
 * Notifications Grid — migrated from Sprockets notifications.js
 * AG Grid v35 APIs
 */
const AgGridPagination = require('../v4/components/ag_grid_pagination');

window.Notifications = {
    _gridApi: null,

    _gridOptions: {
        headerHeight: 44,
        rowHeight: 60,
        columnDefs: null,
        rowData: null,
        pagination: true,
        suppressPaginationPanel: true,
        rowModelType: "infinite",
        paginationAutoPageSize: true,
        maxConcurrentDatasourceRequests: 2,
        cacheOverflowSize: 1,
        infiniteInitialRowCount: 1,
        maxBlocksInCache: 2,
        defaultColDef: {
            resizable: true
        }
    },

    _filters: {
        search_term: '',
        event_types: [],
        specific_date: null,
        start_date: null,
        end_date: null
    },

    _initializeFilters() {
        const $tenderNameField = $("#search_term");
        const $specificDateField = $("#specific_date");
        const $startDateField = $("#start_date");
        const $endDateField = $("#end_date");
        const $eventTypes = $(':checkbox[id^="event_type_"]');
        const $dataRangeFields = $('#date_range_fields');
        const $specificDateFields = $("#specific_date_fields");

        $tenderNameField.keypress(event => {
            if (event.which === 13) {
                event.preventDefault();
                this._filters.search_term = $tenderNameField.val();
                return this._setRowData();
            }
        });

        $("select[id*='select_filter_date']").change(function () {
            if ($("select[id*='select_filter_date'] option:selected").val() === '1') {
                $specificDateFields.show();
                return $dataRangeFields.hide();
            } else if ($("select[id*='select_filter_date'] option:selected").val() === '2') {
                $specificDateFields.hide();
                return $dataRangeFields.show();
            }
        });
        $dataRangeFields.hide();

        $("#specific_date").click(function () {
            $startDateField.val("");
            return $endDateField.val("");
        });

        $("#start_date, #end_date").click(() => $specificDateField.val(""));

        $("#specific_date, #start_date, #end_date").change(() => {
            this._filters.specific_date = $specificDateField.val();
            this._filters.start_date = $startDateField.val();
            this._filters.end_date = $endDateField.val();
            return this._setRowData();
        });

        return $eventTypes.click(e => {
            const eventId = _.last(e.currentTarget.id.split('_'));
            if ($(e.currentTarget).is(':checked')) {
                this._filters.event_types.push(eventId);
            } else {
                this._filters.event_types = _.filter(this._filters.event_types, item => item !== eventId);
            }
            return this._setRowData();
        });
    },

    _setRowData() {
        const dataSource = {
            rowCount: null,
            getRows: params => {
                return $.ajax({
                    url: '/notifications/load_batch',
                    type: 'GET',
                    dataType: 'json',
                    data: { start_row: params.startRow, end_row: params.endRow, filters: this._filters },
                    success(data) {
                        const {
                            rowsCount
                        } = data;
                        return params.successCallback(data.notifications, rowsCount);
                    }
                });
            }
        };
        return this._gridApi.setGridOption('datasource', dataSource);
    },

    _cellRenderer(doc) {
        if (doc.data) {
            return doc.value;
        } else {
            return I18n.t('loading');
        }
    },

    _projectNameRenderer(params) {
        if (params.data) {
            if (!params.data.project_name) { return ''; }
            return `<a href='${params.data.project_url}'>${params.data.project_name}</a>`;
        } else {
            return I18n.t('loading');
        }
    },

    initializeTable() {
        const agGridPagination = AgGridPagination.initialize(this._gridOptions);
        this._gridOptions.onPaginationChanged = agGridPagination.renderPagination.bind(agGridPagination);
        const columnDefs = [
            { headerName: I18n.t('notifications.project_name'), field: 'project_name', cellRenderer: this._projectNameRenderer },
            { headerName: I18n.t('notifications.notification'), field: 'notification', width: 700, cellRenderer: this._cellRenderer },
            { headerName: I18n.t('notifications.date'), field: 'created_at' }
        ];

        this._gridOptions.columnDefs = columnDefs;

        const gridDiv = document.getElementById('notifications-table');
        this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
        this._gridOptions.api = this._gridApi;
        this._gridApi.sizeColumnsToFit();
        this._setRowData();
        this._initializeFilters();
        AgGridPagination.initializePaginationListeners();

        return $(window).resize(() => Notifications._gridApi.sizeColumnsToFit());
    }
};
